import React from 'react';

const steps = [
  {
    n: '1',
    title: 'Configura tus categorías',
    desc: 'Define tus metales, costes y días de procesado de cada tipo de chatarra que compras.',
  },
  {
    n: '2',
    title: 'Calcula el precio máximo',
    desc: 'Selecciona metal y peso. Obtén el precio máximo de compra en segundos, con el riesgo de marcado ya calculado.',
  },
  {
    n: '3',
    title: 'Gestiona el inventario',
    desc: 'Sigue la exposición de cada lote, simula escenarios y vende en el momento óptimo.',
  },
];

export default function LandingHowItWorks() {
  return (
    <section id="como-funciona" style={{ background: '#f8fafc', padding: '100px 24px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <div style={{ maxWidth: 1120, margin: '0 auto' }}>
        {/* Title */}
        <div style={{ textAlign: 'center', marginBottom: 64 }}>
          <h2 style={{ fontSize: 'clamp(1.6rem, 3vw, 2.2rem)', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em', margin: 0 }}>
            Tres pasos para operar con precisión
          </h2>
        </div>

        {/* Steps */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0, position: 'relative' }} className="steps-grid">
          {/* Dashed connector line (desktop) */}
          <div
            style={{
              position: 'absolute',
              top: 28,
              left: 'calc(16.66% + 20px)',
              right: 'calc(16.66% + 20px)',
              height: 1,
              borderTop: '2px dashed #e2e8f0',
              zIndex: 0,
            }}
            className="steps-connector"
          />

          {steps?.map((step, i) => (
            <div key={i} style={{ padding: '0 32px', textAlign: 'center', position: 'relative', zIndex: 1 }} className="step-item">
              {/* Circle */}
              <div style={{
                width: 56,
                height: 56,
                borderRadius: '50%',
                background: '#EA580C',
                color: '#ffffff',
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: 20,
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px',
                boxShadow: '0 4px 16px rgba(234,88,12,0.3)',
              }}>
                {step?.n}
              </div>
              <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#0f172a', marginBottom: 10, letterSpacing: '-0.01em' }}>{step?.title}</h3>
              <p style={{ fontSize: '0.9rem', color: '#64748b', lineHeight: 1.65, margin: 0 }}>{step?.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 640px) {
          .steps-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
          .steps-connector { display: none !important; }
          .step-item { padding: 0 !important; }
        }
      `}</style>
    </section>
  );
}
